
import React from "react";
import { useParams } from "react-router-dom";
import Layout from "@/components/layout/Layout";
import { CountyHeader } from "@/components/nursing-homes/county/CountyHeader";
import { CountyCTASection } from "@/components/nursing-homes/county/CountyCTASection";
import { CountySEO } from "@/components/nursing-homes/county/CountySEO";
import { CountyPageContent } from "@/components/nursing-homes/county/CountyPageContent";
import { useCountyPageData } from "@/hooks/use-county-page-data";

export default function CountyPage() {
  const { countySlug } = useParams();
  const { 
    countyName, 
    nursingHomes, 
    countyOptions, 
    nearbyCounties,
    searchQuery,
    setSearchQuery,
    sortBy,
    setSortBy,
    selectedCounty,
    setSelectedCounty,
    isLoading,
    error,
    countiesLoading,
    countyData,
    filters,
    setFilters,
    activeFilterCount,
  } = useCountyPageData(countySlug);
  
  // Get nursing home count
  const nursingHomeCount = nursingHomes?.length || 0;

  // Create breadcrumbs for this page
  const breadcrumbs = [
    { name: "Home", url: "/" },
    { name: "Nursing Homes", url: "/nursing-homes" },
    { name: countyName, url: `/nursing-homes/${countySlug}` }
  ];

  // Create breadcrumb items for the UI component
  const breadcrumbItems = breadcrumbs.map(item => ({
    label: item.name,
    href: item.url
  }));

  return (
    <Layout>
      <CountySEO 
        countyName={countyName}
        countySlug={countySlug}
        nursingHomeCount={nursingHomeCount}
        breadcrumbs={breadcrumbs}
      />
      
      <CountyHeader 
        countyName={countyName} 
        nursingHomeCount={nursingHomeCount}
      />
      
      <CountyPageContent 
        countyName={countyName}
        countySlug={countySlug}
        nursingHomes={nursingHomes}
        nursingHomeCount={nursingHomeCount}
        breadcrumbItems={breadcrumbItems}
        searchQuery={searchQuery}
        setSearchQuery={setSearchQuery}
        sortBy={sortBy}
        setSortBy={setSortBy}
        selectedCounty={selectedCounty}
        setSelectedCounty={setSelectedCounty}
        countyOptions={countyOptions}
        countiesLoading={countiesLoading}
        isLoading={isLoading}
        error={error}
        countyData={countyData}
        nearbyCounties={nearbyCounties}
        filters={filters}
        setFilters={setFilters}
        activeFilterCount={activeFilterCount}
      />
      
      <CountyCTASection countyName={countyName} />
    </Layout>
  );
}
